import map from 'lodash/map'
import React from 'react'
import { RateCard } from '../RateCard'
import { BillToCustomer } from '../BillToCustomer'
import { CarrierTabs } from '../CarrierTabs'
import { Col, Row } from 'react-bootstrap'
import type { CarrierRate } from '../../../types'
import { useCheckoutContext } from '../../../index'

export const MobileLayout = () => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions

  return (
    <React.Fragment>
      <BillToCustomer />
      <CarrierTabs>
        {(carrierRates, onSelect) => (
          <Row className="g-2">
            {map(carrierRates, (item: CarrierRate, index) => (
              <Col key={item?._id ?? index} md={6} sm={12}>
                <RateCard
                  item={item}
                  amount={item?.shippingAmount}
                  onSelect={() => {
                    onSelect(item)
                  }}
                  active={shippingOptions?.carrierRate?._id === item?._id}
                />
              </Col>
            ))}
          </Row>
        )}
      </CarrierTabs>
    </React.Fragment>
  )
}
